<template>
  <v-carousel
    cycle
    height="400"
    hide-delimiter-background
    show-arrows-on-hover
    v-if="sliders.length > 0"
    :class="{'mb-10': sliders.length > 0}"
  >
    <v-carousel-item
      v-for="(slide, i) in sliders"
      :key="i"
      :src="slide.path"
      reverse-transition="fade-transition"
      transition="fade-transition"
    ></v-carousel-item>
  </v-carousel>
</template>

<script>
  // REPOSITORIES
  import { RepositoryFactory } from '@/repositories/RepositoryFactory'
  const LayoutRepository = RepositoryFactory.get('layout')
  // EVENTS
  import { AUTH_LOGOUT } from '@/store/actions/auth'

  export default {
    data: () => ({
      sliders: [],
    }),

    methods: {
      async getSliders() {
        this.isLoading = true
        let customerApiToken = this.$store.getters.getCustomer.apiToken
        await LayoutRepository
          .getSliders(customerApiToken)
          .then(response => {
            this.isLoading = false
            this.sliders = Object.freeze(response.data)
            EventBus.$emit(LOADED)
            this.filter()
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 403) {
                this.$store
                  .dispatch(AUTH_LOGOUT)
                  .then(() => {
                    this.$router.push('/login').catch(err => {})
                  })
              }
            }
          })
      }
    },

    created() {
      this.getSliders()
    }
  }
</script>